import { Button } from "@shadcn/ui/button";
import { Minus, Plus } from "lucide-react";

type NumberStepperProps = {
	min?: number;
	max?: number;
	step?: number;
	value: number;
	onChange: (value: number) => void;
};

export const NumberStepper = (props: NumberStepperProps) => {
	const { min = 0, max = 99, step = 1, value, onChange } = props;
	const increment = () => onChange(Math.min(value + step, max));
	const decrement = () => onChange(Math.max(value - step, min));

	return (
		<div className="flex w-fit items-center gap-2">
			<Button
				variant="outline"
				size="icon"
				className="flex items-center justify-center touch-manipulation"
				onClick={decrement}
				disabled={value === 0}
				aria-label="Decrease value"
			>
				<Minus className="h-4 w-4" />
			</Button>

			<span className="text-foreground w-6 text-center text-sm leading-5" aria-live="polite" aria-label="Current value">
				{value}
			</span>

			<Button
				variant="outline"
				size="icon"
				className="flex items-center justify-center touch-manipulation"
				onClick={increment}
				disabled={max === value}
				aria-label="Increase value"
			>
				<Plus className="h-4 w-4" />
			</Button>
		</div>
	);
};
